import { takeLatest } from 'redux-saga/effects';

import { GET_ACTIONS } from './constants';
import * as saga from './saga';

export default function*() {
    yield takeLatest(GET_ACTIONS.REQUEST, saga.getActions);
}
